import { Stack } from "@mui/material";

import { cs, HeadingS, Icons } from "@repo/ui";
import PensionCalculator from ".";
import { useDrawer } from "../Drawer/context";
import { ModalContent } from "../Drawer/ModalContent";
import ModalHeader from "../Drawer/ModalHeader";
import { Trigger } from "../Link";

const PensionCalculatorModal = ({
	monthlyContribution,
	onChangeContribution,
}: {
	monthlyContribution: number;
	onChangeContribution: (newContribution?: number) => void;
}) => {
	const { hideDrawer } = useDrawer();
	return (
		<Stack
			sx={{
				width: {
					md: "960px",
				},
				maxWidth: "100%",
				maxHeight: { md: "700px" },
				overflow: "auto",
				transition: "200ms",
			}}
		>
			<ModalHeader>
				<Stack></Stack>
				<HeadingS mb={5} sx={{ mb: 0 }}>
					{cs.pensionCalculator.interactiveCalculator}
				</HeadingS>
				<Trigger onClick={hideDrawer}>
					<Icons.Close sx={{ width: "2rem", height: "2rem" }} />
				</Trigger>
			</ModalHeader>
			<ModalContent forceFullView>
				<Stack pt={6}>
					<PensionCalculator
						onChangeContribution={onChangeContribution}
						monthlyContribution={monthlyContribution}
						portalVersion
					/>
				</Stack>
			</ModalContent>
		</Stack>
	);
};

export default PensionCalculatorModal;
